import { ButtonType, CrudFormConfig, CrudViewFormItemType, FormLayout, InputSize } from '@rappider/rappider-components/utils';
import { Validators } from '@angular/forms';
import { PROJECT_NAME_REGEX } from '../../definitions/regex';

export const PROJECT_MODULE_CREATE_FORM_CONFIG: CrudFormConfig = {
  items: [
    {
      title: 'SHARED.NAME',
      fieldName: 'name',
      type: CrudViewFormItemType.TextBox,
      showRequiredSign: true,
      placeholder: 'Module Name',
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          type: Validators.pattern(PROJECT_NAME_REGEX),
          errorKey: 'pattern',
          errorMessage: 'PROJECT_MODULE.PROJECT_NAME_ERROR'
        }
      ]
    },
    {
      title: 'Categories',
      fieldName: 'categoryIds',
      type: CrudViewFormItemType.TagInput,
      placeholder: 'Select categories',
      options: []
    },
    {
      title: 'SHARED.DESCRIPTION',
      fieldName: 'description',
      placeholder: 'Description',
      type: CrudViewFormItemType.TextArea,
      showRequiredSign: false,
    }
  ],
  submitButton: {
    text: 'Save',
    type: ButtonType.Primary,
    visible: true
  },
  itemSettings: {
    inputComponentSize: {
      xs: 24
    },
    labelComponentSize: {
      xs: 24
    }
  },
  formLayout: FormLayout.Vertical
};
